@if (!!value || showFieldAsEdit) {
  <div class="field">
    <label class="upper">{{ displayName }}</label>
    @if (showFieldAsEdit) {
      <div>
        @if (presetMode) {
          <div>
            <div class="select is-small">
              <select
                [(ngModel)]="numberValue"
                (change)="numberPresetChanged()">
                @for (preset of presetValues; track preset.value) {
                  <option [ngValue]="preset.value">
                    {{ preset.display }}
                  </option>
                }
              </select>
            </div>
          </div>
        }
        @if (!presetMode) {
          <div>
            <topo-duration-select
              [value]="numberValue"
              (valueChanged)="onUpdateValue($event)"></topo-duration-select>
          </div>
        }
      </div>
    } @else {
      <div class="is-readonly">{{ formattedValue }}</div>
    }
  </div>
}
